import * as Yup from "yup";

export const perfisDeEmpresaSchema = Yup.object().shape({
  nomePerfil: Yup.string()
    .required("O Nome é obrigatório")
    .trim()
    .max(20, "Quantidade de caracteres para o campo do CÓDIGO excedida!"),
  perfilAbaIds: Yup.array().of(Yup.number()).notRequired(),
});
